import { render, staticRenderFns } from "./longRent.vue?vue&type=template&id=253ef9be&scoped=true&"
import script from "./longRent.vue?vue&type=script&lang=js&"
export * from "./longRent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253ef9be",
  null
  
)

export default component.exports